module.exports = __webpack_public_path__ + "static/redeemTitle.e2448bf9.png";